import React from "react";
import { Box, Stack } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import styled from "styled-components";
import Tooltip from "@mui/material/Tooltip";
import { round } from "../../../utils/value-formatter";

const CustomSlopeBadge = styled(Box)`
    border-radius: 24px;
    background-color: #5c6367;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const TooltipTitleContent = ({ slope }) => {
    const slopePC = round(slope * 100, 2);
    return (
        <>
            <Stack direction="row" spacing={0.5}>
                <p>Last Month&apos;s Slope</p>
                <p style={{ fontWeight: 300, marginTop: 0 }}>{slopePC}%</p>
            </Stack>
            {Math.abs(slope) > 0 && (
                <p style={{ fontWeight: 300, marginTop: 0 }}>
                    Meaning that for the last month there was in average a {slopePC}% change of the
                    value each day.
                </p>
            )}
        </>
    );
};

const SlopeBadge = ({ slope }) => {
    if (typeof slope !== "number") return null;
    const minSlope = -1;
    const maxSlope = 1;
    const maxRotation = 90;

    const rotation = Math.max(-maxRotation, Math.min(maxRotation, slope * maxRotation));

    let color;
    if (slope > 0) {
        const greenIntensity = Math.min(255, Math.floor(255 * ((slope * 5) / maxSlope)));
        color = `rgba(${255 - greenIntensity}, 255, ${255 - greenIntensity}, 1)`;
    } else if (slope < 0) {
        const orangeIntensity = Math.min(
            255,
            Math.floor(255 * (Math.abs(slope * 5) / Math.abs(minSlope)))
        );
        color = `rgba(255, ${255 - orangeIntensity}, ${255 - orangeIntensity}, 1)`;
    } else {
        color = "white";
    }
    return (
        <Stack direction="row" ml={0.5} mr={4} alignItems="center">
            <CustomSlopeBadge>
                <Tooltip title={<TooltipTitleContent slope={slope} />}>
                    {slope === 0 ? (
                        <HorizontalRuleIcon
                            style={{
                                transform: `rotate(${-rotation}deg)`,
                                color,
                            }}
                        />
                    ) : (
                        <ArrowRightAltIcon
                            style={{
                                transform: `rotate(${-rotation}deg)`,
                                color,
                            }}
                        />
                    )}
                </Tooltip>
            </CustomSlopeBadge>
        </Stack>
    );
};
export default SlopeBadge;
